module.exports = __webpack_public_path__ + "img/仓储物流.7e018e5e.png";